import { lazy } from 'react';

export * from './confirmOpenAPISpecDelete';
export * from './filesystem-util';
export * from './OpenAPIAddSpecButton';
export * from './OpenAPIComputedIncentiveAlert';
export * from './OpenAPIEmptyState';
export * from './OpenAPIProcessingError';
export * from './OpenAPIShareFeedbackButton';
export * from './OpenAPISpecCreateDialog';
export * from './OpenAPISpecEditDialog';
export * from './OpenAPISpecPicker';
export * from './OpenAPISpecSelector';
export * from './OpenAPIWaitForSpec';

export const OpenAPISpecEditor = lazy(() =>
    import('./OpenAPISpecEditor.lazy').then((module) => ({
        default: module.OpenAPISpecEditor,
    }))
);
